// extracted by mini-css-extract-plugin
export default {"label":"CustomInput_label__0DafH"};